class Confirmation extends Inscription {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		super.initialize();
	}
}